import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiEvsService} from './ApiEvs.service';

// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export class SettingService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  getDetailSettingActive() {
    return this.get_qr_core_aps('/setting/batch/product/reassign/list');
  }

  updateSettingActive(body) {
    return this.put_qr_core_aps('/setting/batch/product/reassign/v2', body);
  }

  getDetailSettingConfig() {
    return this.get_qr_aps('/sale-out-setting');
  }

  updateSettingConfig(body) {
    return this.post_qr_aps('/sale-out-setting', body)
  }

  /**TuanBa: 16/09/2022: Cấu hình on off hiện thị thông tin sẩn phẩm**/
  getSettingViewProduct() {
    return this.get_qr_core_aps('/settings/widget/scan')
  }

  updateSettingViewProduct(code, body) {
    return this.put_qr_core_aps(`/settings/widget/scan/${code}`, body)
  }

  getTransferSetting() {
    return this.get('/qr_aps/transfer/setting');
  }
  postTransferSetting(body) {
    return this.put('/qr_aps/transfer/setting', body);
  }

  /**
   * TuanBA: 24/08/2023: Cấu hình retarget
   **/
  getInfoRetarget() {
    return this.get_qr_core_aps('/company/retarget')
  }
  updateInfoRetarget(body) {
    return this.put_qr_core_aps('/company/retarget', body)
  }

  /**
   * TuanBA: 24/08/2023: Cấu hình retarget
   **/
  getInforOTP() {
    return this.get_qr_core_aps('/account/otp_config')
  }
  updateInforOTP(body) {
    return this.put_qr_core_aps('/account/otp_config', body)
  }

  /**
   * Cấu hình kiểm tra thị trường
   **/
  getMarketSurveyConfig() {
    return this.get_qr_core_aps('/account/location_market_inspection')
  }
  updateMarketSurveyConfig(body) {
    return this.put_qr_core_aps('/account/location_market_inspection', body)
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/Setting.service.ts